export const currentUser = state => state.user.data
